<template>
  <div v-loading="loading" class="nx-page nx-report-page kanban-device-alarm-board">
    <nx-report-header
      title="设备报警信息看板"
    >
      <div class="kb-header-actions">
        <el-button size="small" icon="el-icon-pie-chart" @click="goCountStats">数量统计与分类</el-button>
        <el-button size="small" icon="el-icon-data-analysis" @click="goAnalysis">故障统计分析</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="loadData">刷新</el-button>
      </div>
    </nx-report-header>

    <el-form :inline="true" class="kb-filter-bar" size="small" @submit.native.prevent>
      <el-form-item label="提醒级别">
        <el-select v-model="filters.alertType" clearable placeholder="全部" style="width: 110px">
          <el-option label="一级" value="一级" />
          <el-option label="二级" value="二级" />
          <el-option label="三级" value="三级" />
        </el-select>
      </el-form-item>
      <el-form-item label="报警类型">
        <el-select v-model="filters.type" clearable placeholder="全部" style="width: 120px">
          <el-option label="设备故障" value="设备故障" />
          <el-option label="安全隐患" value="安全隐患" />
          <el-option label="检修" value="检修" />
          <el-option label="其他" value="其他" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.alertStatus" clearable placeholder="全部" style="width: 110px">
          <el-option label="待确认" :value="0" />
          <el-option label="处理中" :value="1" />
          <el-option label="已处理" :value="2" />
          <el-option label="已关闭" :value="4" />
        </el-select>
      </el-form-item>
      <el-form-item label="设备分类">
        <el-select v-model="filters.category" clearable placeholder="全部" style="width: 100px">
          <el-option label="机电" value="机电" />
          <el-option label="电气" value="电气" />
          <el-option label="配件" value="配件" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="resetFilters">重置筛选</el-button>
      </el-form-item>
    </el-form>

    <div class="kb-kpi-row">
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">今日报警</div>
        <div class="kb-kpi-value" :class="{ 'is-warn': kpi.today > 0 }">{{ kpi.today }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">未关闭</div>
        <div class="kb-kpi-value" :class="{ 'is-danger': kpi.open > 5 }">{{ kpi.open }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">一级且未关闭</div>
        <div class="kb-kpi-value" :class="{ 'is-danger': kpi.level1Open > 0 }">{{ kpi.level1Open }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">近 7 日累计</div>
        <div class="kb-kpi-value">{{ kpi.week }}</div>
      </div>
    </div>

    <div class="kb-charts-row">
      <div class="kb-chart-card">
        <div class="kb-chart-head">
          <span>近 7 日报警趋势</span>
          <small>按报警发生日统计</small>
        </div>
        <div ref="trendChart" class="kb-chart-box" />
      </div>
      <div class="kb-chart-card">
        <div class="kb-chart-head">
          <span>状态分布</span>
          <small>当前筛选结果</small>
        </div>
        <div ref="statusChart" class="kb-chart-box" />
      </div>
    </div>

    <div class="kb-section">
      <div class="kb-section-head">
        <span>报警清单</span>
        <span style="font-size: 12px; color: #64748b">共 {{ filteredList.length }} 条</span>
      </div>
      <el-table :data="pagedTable" border stripe size="small" max-height="480" style="width: 100%">
        <el-table-column prop="alertTime" label="报警时间" width="158" :formatter="fmtTime" />
        <el-table-column prop="deviceName" label="设备名称" min-width="120" show-overflow-tooltip />
        <el-table-column label="安装位置" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ deviceLocationText(row) }}</template>
        </el-table-column>
        <el-table-column prop="category" label="分类" width="72" />
        <el-table-column prop="type" label="类型" width="96" />
        <el-table-column prop="alertType" label="级别" width="72">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeLevel(row.alertType)" size="mini">{{ row.alertType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="当前值/阈值" width="120" align="right">
          <template slot-scope="{ row }">{{ row.currentValue }} / {{ row.thresholdValue }}</template>
        </el-table-column>
        <el-table-column prop="alarmContent" label="报警内容" min-width="160" show-overflow-tooltip />
        <el-table-column label="处理机制" width="96">
          <template slot-scope="{ row }">{{ mechText(row.handlingMechanism) }}</template>
        </el-table-column>
        <el-table-column prop="alertStatus" label="状态" width="88">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeStatus(row.alertStatus)" size="mini">{{ statusText(row.alertStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="processorName" label="处理人" width="88" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.processorName || '—' }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="filteredList.length > pageSize"
        style="margin-top: 12px; text-align: right"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="filteredList.length"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as echarts from 'echarts'
import NxReportHeader from '@/components/nx/report/NxReportHeader.vue'
import { fetchDeviceAlarmBoard } from './api'
import { MECH_LABEL, STATUS_LABEL } from '../utils/mockDeviceAlarms'

export default {
  name: 'KanbanDeviceAlarmBoard',
  components: { NxReportHeader },
  data() {
    return {
      loading: false,
      rawList: [],
      filters: {
        alertType: '',
        type: '',
        alertStatus: '',
        category: ''
      },
      kpi: { today: 0, open: 0, level1Open: 0, week: 0 },
      chartInstances: [],
      page: 1,
      pageSize: 15
    }
  },
  computed: {
    filteredList() {
      return this.rawList.filter((r) => {
        if (this.filters.alertType && r.alertType !== this.filters.alertType) return false
        if (this.filters.type && r.type !== this.filters.type) return false
        if (this.filters.alertStatus !== '' && this.filters.alertStatus != null && r.alertStatus !== this.filters.alertStatus) return false
        if (this.filters.category && r.category !== this.filters.category) return false
        return true
      })
    },
    pagedTable() {
      const start = (this.page - 1) * this.pageSize
      return this.filteredList.slice(start, start + this.pageSize)
    }
  },
  watch: {
    filteredList: {
      handler() {
        this.page = 1
        this.buildKpi()
        this.$nextTick(() => this.renderCharts())
      }
    }
  },
  mounted() {
    this.loadData()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    this.disposeCharts()
  },
  methods: {
    statusText(s) {
      return STATUS_LABEL[s] != null ? STATUS_LABEL[s] : String(s)
    },
    mechText(m) {
      return MECH_LABEL[m] || '—'
    },
    tagTypeLevel(a) {
      if (a === '一级') return 'danger'
      if (a === '二级') return 'warning'
      return 'success'
    },
    tagTypeStatus(s) {
      if (s === 0) return 'warning'
      if (s === 1) return 'primary'
      if (s === 2) return 'info'
      return 'success'
    },
    fmtTime(row, col, val) {
      return val ? moment(val).format('YYYY-MM-DD HH:mm') : '—'
    },
    /** 安装位置：BaseDeviceManageEntity.deviceLocation */
    deviceLocationText(row) {
      const d = row && row.device
      if (d && d.deviceLocation) return d.deviceLocation
      return '—'
    },
    goAnalysis() {
      this.$router.push('/kanban-management/device-fault-analysis')
    },
    goCountStats() {
      this.$router.push('/kanban-management/device-alarm-count-stats')
    },
    resetFilters() {
      this.filters = { alertType: '', type: '', alertStatus: '', category: '' }
    },
    async loadData() {
      this.loading = true
      try {
        const res = await fetchDeviceAlarmBoard({})
        this.rawList = (res && res.list) || []
        this.buildKpi()
        this.$nextTick(() => this.renderCharts())
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    buildKpi() {
      const list = this.filteredList
      const startOfDay = moment().startOf('day').valueOf()
      const weekAgo = moment().startOf('day').subtract(6, 'day').valueOf()
      const today = list.filter((r) => r.alertTime >= startOfDay).length
      const open = list.filter((r) => r.alertStatus !== 4).length
      const level1Open = list.filter((r) => r.alertType === '一级' && r.alertStatus !== 4).length
      const week = list.filter((r) => r.alertTime >= weekAgo).length
      this.kpi = { today, open, level1Open, week }
    },
    disposeCharts() {
      this.chartInstances.forEach((c) => c && c.dispose())
      this.chartInstances = []
    },
    onResize() {
      this.chartInstances.forEach((c) => c && c.resize())
    },
    renderCharts() {
      this.disposeCharts()
      const list = this.filteredList
      const days = []
      for (let i = 6; i >= 0; i--) {
        days.push(moment().startOf('day').subtract(i, 'day'))
      }
      const keys = days.map((d) => d.format('YYYY-MM-DD'))
      const counts = keys.map((key) =>
        list.filter((r) => moment(r.alertTime).format('YYYY-MM-DD') === key).length
      )

      const t = echarts.init(this.$refs.trendChart)
      t.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '12%', containLabel: true },
        xAxis: { type: 'category', data: keys.map((k) => k.slice(5)), axisLabel: { color: '#64748b' } },
        yAxis: { type: 'value', minInterval: 1, axisLabel: { color: '#64748b' } },
        series: [
          {
            type: 'line',
            smooth: true,
            data: counts,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(220,38,38,0.22)' },
                { offset: 1, color: 'rgba(220,38,38,0.02)' }
              ])
            },
            lineStyle: { color: '#dc2626', width: 2 },
            itemStyle: { color: '#dc2626' }
          }
        ]
      })
      this.chartInstances.push(t)

      const st = { 0: 0, 1: 0, 2: 0, 4: 0 }
      list.forEach((r) => {
        if (st[r.alertStatus] !== undefined) st[r.alertStatus]++
      })
      const pieData = [
        { name: '待确认', value: st[0] },
        { name: '处理中', value: st[1] },
        { name: '已处理', value: st[2] },
        { name: '已关闭', value: st[4] }
      ].filter((x) => x.value > 0)

      const p = echarts.init(this.$refs.statusChart)
      p.setOption({
        tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
        legend: { bottom: 0, textStyle: { color: '#64748b', fontSize: 11 } },
        series: [
          {
            type: 'pie',
            radius: ['42%', '68%'],
            center: ['50%', '46%'],
            data: pieData.length ? pieData : [{ name: '无数据', value: 1, itemStyle: { color: '#e2e8f0' } }],
            label: { formatter: '{b}\n{d}%', fontSize: 11 }
          }
        ]
      })
      this.chartInstances.push(p)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';

.kb-header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
</style>
